import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import * as Highcharts from "highcharts";
import { DashboardDepartementService } from "../../core/service/dashboard-departement.service";
import { Direction } from "src/app/parametrage/core/model/direction";
import { Departement } from "src/app/parametrage/core/model/departement";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { DirectionService } from "src/app/parametrage/core/service/direction.service";
import { DepartementService } from "src/app/parametrage/core/service/departement.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";

@Component({
  selector: "app-depart-productivite",
  templateUrl: "./depart-productivite.component.html",
  styleUrls: ["./depart-productivite.component.scss"],
})
export class DepartProductiviteComponent implements OnInit {
  directions: Direction[];
  departements: Departement[];
  departement: Departement;

  currentEmployee: Employee;

  highcharts = Highcharts;
  chartOptions1: any;

  constructor(
    private modalService: NgbModal,
    private _dashboardDepartementService: DashboardDepartementService,
    private _drectionService: DirectionService,
    private _departementService: DepartementService,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService
  ) {}

  ngOnInit() {
    this.getDirections();
    this.getCurrentEmployee();
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
        this.departement = this.currentEmployee.departement;
        this.rankingTacheEnRetard(this.departement);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDepartementsByDirection(directionid) {
    this._departementService.getDepartementsByDirection(directionid).subscribe(
      (data) => {
        this.departements = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * Ranking
   */

  rankingTacheEnRetard(departement) {
    this._dashboardDepartementService
      .rankingTacheEnRetard(departement.id)
      .pipe(first())
      .subscribe(
        (data) => {
          const series = [];
          const categories = data.map((item) => item.name);
          const seriesData = data.map((item) => item.valeur);
          series.push({ name: "Retard", data: seriesData });

          this.chartOptions1 = {
            chart: {
              type: "bar",
            },
            title: {
              text:
                "Retard (en jour) des agents du département " +
                departement.label,
            },
            subtitle: {
              text: null,
            },
            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              //x: 250,
              y: 100,
              floating: false,
              borderWidth: 1,
              backgroundColor: "#FFFFFF",
              shadow: true,
            },
            xAxis: {
              categories: categories,
              title: {
                text: null,
              },
            },
            yAxis: {
              min: 0,
              title: {
                text: "Retard en jour",
                align: "high",
              },
              labels: {
                overflow: "justify",
              },
            },
            tooltip: {
              valueSuffix: " Jour(s)",
            },
            plotOptions: {
              bar: {
                dataLabels: {
                  enabled: true,
                },
                showInLegend: true,
              },
              series: {
                stacking: "normal",
              },
            },
            credits: {
              enabled: false,
            },
            series: series,
          };
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
